// extracted by mini-css-extract-plugin
module.exports = {"warningWrapper":"B_sY g_df g_fk g_ft g_fn g_c6 g_dK g_fx","btn":"B_p g_gj g_fH g_g8 g_g0"};